"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewExpressBaggage = function NewExpressBaggage() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.3846 15.6153H9.88462V7.0769H11.3846V15.6153Z",
    fill: "#6E6D71"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.2692 15.6153H13.7692V7.0769H15.2692V15.6153Z",
    fill: "#6E6D71"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53102 17.9689C6.88503 18.3229 7.31057 18.5 7.80767 18.5V18.6153C7.80767 18.8602 7.8939\n19.0688 8.06635 19.2413C8.23878 19.4137 8.44743 19.5 8.6923 19.5C8.93717 19.5 9.14582 19.4137\n9.31825 19.2413C9.49068 19.0688 9.5769 18.8602 9.5769 18.6153V18.5H15.5769V18.6153C15.5769 18.8602\n15.6631 19.0688 15.8356 19.2413C16.008 19.4137 16.2166 19.5 16.4615 19.5C16.7064 19.5 16.915\n19.4137 17.0875 19.2413C17.2599 19.0688 17.3461 18.8602 17.3461 18.6153V18.5C17.8432 18.5 18.2688\n18.3229 18.6228 17.9689C18.9768 17.6149 19.1538 17.1894 19.1538 16.6923V5.99998C19.1538 5.50286\n18.9768 5.0773 18.6228 4.7233C18.2688 4.3693 17.8432 4.1923 17.3461 4.1923H15.2692V2.3077C15.2692\n1.81058 15.0922 1.38503 14.7382 1.03103C14.3842 0.677009 13.9586 0.5 13.4615 0.5H11.6923C11.1952\n0.5 10.7696 0.677009 10.4156 1.03103C10.0616 1.38503 9.88462 1.81058 9.88462\n2.3077V4.1923H7.80767C7.31057 4.1923 6.88503 4.3693 6.53102 4.7233C6.17701 5.0773 6 5.50286 6\n5.99998V16.6923C6 17.1894 6.17701 17.6149 6.53102 17.9689ZM17.3461 17H7.80767C7.71792 17 7.64421\n16.9711 7.58653 16.9134C7.52883 16.8557 7.49998 16.782 7.49998 16.6923V5.99998C7.49998 5.91023\n7.52883 5.8365 7.58653 5.7788C7.64421 5.7211 7.71792 5.69225 7.80767 5.69225H17.3461C17.4359\n5.69225 17.5096 5.7211 17.5673 5.7788C17.625 5.8365 17.6538 5.91023 17.6538 5.99998V16.6923C17.6538\n16.782 17.625 16.8557 17.5673 16.9134C17.5096 16.9711 17.4359 17 17.3461 17ZM13.7692\n4.1923H11.3846V2.3077C11.3846 2.21795 11.4134 2.14423 11.4711 2.08653C11.5288 2.02883 11.6026\n1.99998 11.6923 1.99998H13.4615C13.5512 1.99998 13.625 2.02883 13.6827 2.08653C13.7404 2.14423\n13.7692 2.21795 13.7692 2.3077V4.1923Z",
    fill: "#6E6D71"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 6V7.5H4.80775V6H1Z",
    fill: "#6E6D71"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 10V11.5H4.80775V10H0Z",
    fill: "#6E6D71"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 14V15.5H4.80775V14H1Z",
    fill: "#6E6D71"
  }));
};
var _default = NewExpressBaggage;
exports.default = _default;